module.exports = "/_next/static/images/bank-96482a912b8486f2199065bf640d3274.png";